'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var shouldShowButton = function (height, maxHeight) {
    return height > maxHeight;
};

exports.shouldShowButton = shouldShowButton;
//# sourceMappingURL=utils.js.map
